//#region imports
import React, { useMemo } from 'react';

// grouped passenger icon
import GroupedPassengerIcon from '../grouped-passenger-icon';

// redux
import { useSelector } from 'react-redux';
import { selectRemovePaxNamePrefix } from "_redux/slices/timeline/timeline-control";

// utils functions
import { processName } from '_utils/functions';

//#endregion

const JobName = (props) => {

    // redux
    const removePrefixName = useSelector(selectRemovePaxNamePrefix)                 // If true, remove prefix like Mr,Ms from passenger name

    //#endregion

    //#region derive name (memoized)
    const displayName = useMemo(() => {
        let name = "";

        // check if job is not combined booking or ramp booking
        if (props?.job && !props?.job?.combinedBooking && !props?.job?.combinedRampBooking) {

            // check job has pax info
            if (props?.job.passengerInformation) {
                if (props.job.passengerInformation.name) {
                    // set name
                    name = props.job.passengerInformation.name;
                }
                else if (props.job.passengerInformation.title) {
                    // set name
                    name = props.job.passengerInformation.title;
                }
            }
            else if (props?.job.name) {

                // check if it is a connection passenger
                if(props?.job?.originalBookingDoc?.onwards){
                    // always set name for connection passengers even if unassigned
                    name = props?.job?.originalBookingDoc?.name;
                }
                else if (props.job.bookingType === "DUPLICATE") {
                    const partNumber = props.job._id.split("-part")[1]
                    name = `${props.job.name} part${partNumber}`
                } else name = props.job.name;
            }
            // check if its a task
            else {
                // only set arrival name if it has been assigned
                if (props?.assignedTime == true) {

                    // arrival tasks should show name
                    if (props.job.passengerInformation) {
                        if (props.job.passengerInformation.name) {
                            name = props.job.passengerInformation.name;
                        }
                        else if (props.job.passengerInformation.title) {
                            name = props.job.passengerInformation.title;
                        }
                    }
                    else if (props.job.name) {
                        name = props.job.name;
                    }
                }
            }
        }
        else {
            // combined booking
            if (props?.job?.combinedRampBooking) {
                // check if marshall or ramp task
                if (props?.job?.combinedMarshallBooking) {
                    name = 'Marshall Task'
                }
                else {
                    name = 'Ramp Task'
                }
            }
            else if (props?.job?.jobType == 'boarding') {
                name = 'Boarding Task'
            }
        }

        // remove prefix from name
        if (removePrefixName && name) {
            return processName(name, true);
        } else {
            return processName(name);
        }

    }, [removePrefixName, props.job]);
    //#endregion

    // is ramp / group booking
    const isBoarding = props?.job?.jobType == 'boarding' || props?.job?.combinedBooking || false;
    const isRampTask = props?.job?.jobType == 'ramp-task' || false;
    const isGroupedTask = props?.job?.groupedBooking || false;
    const isFlightTask = props?.job?.flightTask || false;

    return (
        <div>

            {/* grouped job */}
            {isBoarding || isRampTask || isGroupedTask || isFlightTask ?
                <div>
                    {/* <p style={{ margin: "0px 0", fontSize: 10, fontWeight: "500" }}> */}
                    {/* {isBoarding ? "Boarding Task" : "Ramp Task"} */}
                    {/* {formatJobName()}
                    </p> */}
                    <GroupedPassengerIcon
                        groupedPassengers={props?.job?.passengers}
                        flightType={props.flightType}
                        job={props?.job}
                    />
                </div>
                :
                /* pax name */
                <p style={{
                    margin: "0px 0",
                    fontSize: 10,
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100%"
                }} {...(displayName !== "" ? { 'data-tippy-content': displayName } : {})}>
                    {displayName}
                </p>

            }
        </div>
    );
};

export default React.memo(JobName, (prev, next) => prev.job === next.job);
